// @flow
import React from 'react';
import prop from 'ramda/es/prop';
import { useTranslation } from 'react-i18next';

import Button from 'app/common/ui/Button';
import IconCross from 'app/common/icons/IconLightCross';
import { IconBtnPlug } from 'app/components/_Icons';
import NotEnoughLink from 'app/components/Tariff/NotEnoughLink';
import subPayment from 'app/containers/Subs/subPayment';

import Confirmation from '../Confirmation';
import confirmationStateHOC from '../Confirmation/confirmationState';
import type { Sub } from '../Tariff';
import styles from './ButtonsStandart.scss';


type Props = {
  sub: Sub,
  subId: number | string,
  stopping: boolean,
  pausingResuming: boolean,
  subscribing: boolean,
  saving: boolean,
  handlePayToday: (e: SyntheticEvent<HTMLElement>) => void,
  handlePause: (e: SyntheticEvent<HTMLElement>) => void,
  handleStop: (e: SyntheticEvent<HTMLElement>) => void,
  handleSubscribe: (e: SyntheticEvent<HTMLElement>) => void,
  footnotes: Object,
  // From enhance. Состояние подтверждения действия, другие кнопки должны быть скрыты
  confirmationState: string,
  beginConfirmation: (e: SyntheticEvent<HTMLElement>) => void,
  stopConfirmation: (void) => void,
  subscribeText?: string,
  notPaid: boolean,
  bundleWarn?: string,
};

const ButtonsStandart = ({
  sub,
  subId,
  stopping,
  pausingResuming,
  subscribing,
  saving,
  handlePayToday,
  handlePause,
  handleStop,
  handleSubscribe,
  footnotes,
  confirmationState,
  beginConfirmation,
  stopConfirmation,
  subscribeText: st,
  notPaid,
  bundleWarn,
}: Props) => {
  const { t } = useTranslation('tariff');
  const subscribeText = st || t('subscribe_bt');

  return (
    <div className={styles.buttons}>
      {sub
        && notPaid
        && (!confirmationState || confirmationState === 'payready')
        && !prop('is_paused', sub)
        && <Confirmation
          onSubmit={handlePayToday}
          comment={
            <span>
              {t('paynow_confirm')}
              {footnotes.paytoday && <sup className={styles.fn}>{footnotes.paytoday.index}</sup>}
            </span>
          }
          beginConfirmation={beginConfirmation}
          stopConfirmation={stopConfirmation}
          name="payready"
        >
          {handle =>
            <div className={styles.paytoday}>
              <NotEnoughLink handlePay={handle} disabled={saving} name="payready" subId={subId} />
              {footnotes.paytoday && <sup className={styles.fnPaytoday}>{footnotes.paytoday.index}</sup>}
            </div>}
        </Confirmation>}

      <div className={styles.space} />

      {sub && false && <a href="paynow" onClick={handlePayToday} className={styles.paytoday}>
        <span>
          {t('paynow_bt')}
        </span>
        <sup className={styles.fnPaytoday}>3</sup>
      </a>}

      {sub && (!confirmationState || confirmationState === 'pause')
        && <Confirmation
          onSubmit={handlePause}
          comment={t('pause_confirm', {
            action: t('pause_confirm_action', { context: sub.is_paused ? 'off' : 'on' }),
          })}
          beginConfirmation={beginConfirmation}
          stopConfirmation={stopConfirmation}
        >
          {handle =>
            <Button
              outline={!sub.is_paused}
              warning={!sub.is_paused}
              error={sub.is_paused}
              onClick={handle}
              disabled={pausingResuming || stopping || subscribing}
              name="pause"
            >
              {t('pause_bt', { context: sub.is_paused ? 'on' : 'off' })}
              {!sub.is_paused && footnotes.pause && <sup>{footnotes.pause.index}</sup>}
              {sub.is_paused
                ? <span className={styles.iconPlay}>&#9654;</span>
                : <span className={styles.iconPause}>&#9616;&#9616;</span>}
            </Button>}
        </Confirmation>}

      {sub && (!confirmationState || confirmationState === 'stop')
        && <Confirmation
          onSubmit={handleStop}
          comment={t('stop_confirm')}
          beginConfirmation={beginConfirmation}
          stopConfirmation={stopConfirmation}
        >
          {handle =>
            <Button error onClick={handle} disabled={stopping || pausingResuming || subscribing} name="stop">
              {stopping ? t('stop_bt_loading') : t('stop_bt')}
              {footnotes.stop && <sup>{footnotes.stop.index}</sup>}
              <IconCross className={styles.icon} />
            </Button>}
        </Confirmation>}

      {!sub && (!confirmationState || confirmationState === 'tariff')
        && <Confirmation
          onSubmit={handleSubscribe}
          comment={bundleWarn || t('connect_confirm')}
          beginConfirmation={beginConfirmation}
          stopConfirmation={stopConfirmation}
        >
          {handle =>
            <Button warning onClick={handle} name="tariff" disabled={subscribing}>
              {subscribing ? t('connect_bt_loading') : subscribeText}
              <IconBtnPlug className={styles.icon} />
            </Button>}
        </Confirmation>}
    </div>
  );
};

export default confirmationStateHOC(subPayment(ButtonsStandart));
